import React from "react";
import { Layout, Menu, Icon } from "antd";
import { Switch, BrowserRouter, Route, Link, Redirect } from "react-router-dom";
import siderMenu from "../../constants/sider-menus";
import Router from "../../Router";
import Logo from "../../assets/images/favicon.png";

const { SubMenu } = Menu;

const { Sider } = Layout;
class HomePage extends React.Component {
  render() {
    return (
      <React.Fragment>
        <Sider
          breakpoint="lg"
          collapsedWidth="0"
          onBreakpoint={(broken) => {
            console.log(broken);
          }}
          onCollapse={(collapsed, type) => {
            console.log(collapsed, type);
          }}
        >
          <div className="siderTitle">
            <img style={{ width: 30, height: 30 }} src={Logo}></img>&nbsp;
            试试如意运营系统
          </div>
          <Menu theme="dark" mode="inline">
            {siderMenu.map((item) =>
              item.sub ? (
                <SubMenu
                  key={item.key}
                  title={
                    <span>
                      <Icon type={item.icon} />
                      <span style={{ color: "#FFF" }}>{item.name}</span>
                    </span>
                  }
                >
                  {item.sub.map((item) => (
                    <Menu.Item key={item.key}>
                      <Link
                        style={{ color: "rgba(255,255,255,1)" }}
                        to={item.path}
                      >
                        <span style={{ color: "#FFF" }}>{item.name}</span>
                      </Link>
                    </Menu.Item>
                  ))}
                </SubMenu>
              ) : (
                <Menu.Item key={item.key}>
                  <Link style={{ color: "rgba(255,255,255,1)" }} to={item.path}>
                    <Icon type={item.icon} />
                    <span style={{ color: "#FFF" }}>{item.name}</span>
                  </Link>
                </Menu.Item>
              )
            )}
          </Menu>
        </Sider>
        <Layout style={{ position: "relative" }}>
          <Router></Router>
        </Layout>
      </React.Fragment>
    );
  }
}
export default HomePage;
